import { startCase } from 'lodash'

export const formatCurrency = (value, currency = 'USD') =>
	value !== undefined
		? new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: 0 }).format(value)
		: '-'

export const getStartCase = v => startCase(v)
